export default {
    // icon1: "/pc/static/image/index-icon-1.jpg",
    // icon2: "/pc/static/image/index-icon-2.jpg",
    // icon3: "/pc/static/image/index-icon-3.jpg",
    icon1: "/pc/static/image/home_safe_icon.png",
    icon2: "/pc/static/image/home_Lock_icon.png",
    icon3: "/pc/static/image/home_consumer_icon.png",
    langzh: "/pc/static/image/zh_flag.png",
    langen: "/pc/static/image/en_flag.png",
    langtw:  "/pc/static/image/tw_flag.png",
    langjp: "/pc/static/image/jp_flag.png",
    langxby: "/pc/static/image/xby_flag.png",
    langty: "/pc/static/image/ty_flag.png",
    langhy: "/pc/static/image/hy_flag.png",
    langdy: "/pc/static/image/dy_flag.png",
    langfy: "/pc/static/image/fy_flag.png",
    langyn: "/pc/static/image/yn_flag.png",
    langydl: "/pc/static/image/it.jpeg",
    langpty: "/pc/static/image/pt.jpeg",
    zhsz: "/pc/static/image/icon-zhsz.png",
    jtrz: "/pc/static/image/icon-jyrz.png",
    sfrz: "/pc/static/image/icon-sfrz.png",
    iconchecked: "/pc/static/image/icon-checked.png",
    iconcheck: "/pc/static/image/icon-check.png",
    // iconbg: '/pc/static/image/index-bg.png',
     iconbg: '/pc/static/image/home_phone.png',
    indexphone: '/pc/static/image/index-phone.png',
    icon1_01: "/pc/static/image/pic1.png",
    icon1_02: "/pc/static/image/pic2.png",
    icon1_03: "/pc/static/image/pic3.png",
    icon1_04: "/pc/static/image/pic4.png",
    banner01: "/pc/static/image/pict1.png",
    banner02: "/pc/static/image/pict2.png",
    banner03: "/pc/static/image/pict3.png",
}



// WEBPACK FOOTER //
// ./src/utils/pic.js